import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import * as Styled from "../../components/confirmation-page/styles";
import { hideHeader } from "../../actions/appStatus.actions";
import { getWebsiteUrl } from "../../utils/content";

const LinkIsNoLongerValidComponent = ({ hideHeader }) => {
  useEffect(() => window.scrollTo(0, 0), []);
  useEffect(() => hideHeader(), []);
  return (
    <div className="container app-container" style={{ textAlign: "center", marginTop: "60px" }}>
      <div className="row">
        <div className="col-12">
          <Styled.PageHeading>Link is no longer valid</Styled.PageHeading>
          <p>
            The link you have been provided has expired.  Please give us a call at <a href="tel:8882677200">888.267.7200</a> if you require further assistance.
          </p>
          <Styled.TransparentBtn>
            <a href={getWebsiteUrl()} className="transparent-btn" style={{ color: "#00558C" }}>
              Laketrust.org
            </a>
          </Styled.TransparentBtn>
        </div>
      </div>
    </div>
  );
};

// Map global store to component props
const mapStateToProps = state => state;

// Hook up actions to component
const mapDispatchToProps = {
  hideHeader
};

//Connect to Redux store
const LinkIsNoLongerValid = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LinkIsNoLongerValidComponent)
);

export default LinkIsNoLongerValid;


// WEBPACK FOOTER //
// ./src/pages/home-equity-appraisal/link-is-no-longer-valid.component.js